<template>
	<div class="pl-2 pr-2 indent">
		<div align="center">
			<v-icon color="primary" size="170">mdi-school</v-icon>
		</div>
		<div align="center">
			<h3>Centro+</h3>
			<h4>Miguel De Olim</h4>
			<a href="migueldeolim1@gmail.com">
				<i class=" fas fa-envelope"></i> migueldeolim1@gmail.com
			</a>
		</div>
		<br />

		<p class="indent" align="justify">
			Apliación web con el objetivo de ofrecerle a los estudiantes un conjunto de herramientas
			de la mano del centro de estudiante.
		</p>
		<p class="indent" align="justify">
			Busca ser una solución a distintos problemas del día a día ucabista.
		</p>

		<div align="center">
			<h4>¿Tuviste o tienes un problema?</h4>

			<v-btn href="https://forms.gle/herjVeNRAAUKpM2m9" outlined color="primary" block
				>¡Reportarlo!</v-btn
			>
		</div>
		<br />
		<p align="center">V. 2.2.2</p>
	</div>
</template>

<script>
import store from "../store/index";

export default {
	created() {
		store.commit("toggleTabs", false);
	}
};
</script>

<style>
p.indent {
	text-indent: 15px;
}
</style>
